import React, { FC } from 'react'

type IconProps = {
  className?: string
}

export const GraduateIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'30'}
      viewBox={'0 0 29 30'}
      width={'29'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g clipPath={'url(#clip0_4357_1174)'}>
        <path
          clipRule={'evenodd'}
          d={
            'M11.2888 16.8628L18.306 13.2484L25.3228 16.8628C25.3267 16.8645 25.3271 16.872 25.3232 16.8745L18.306 21.7503L11.2884 16.8745C11.2845 16.872 11.2849 16.8645 11.2888 16.8628Z'
          }
          fillRule={'evenodd'}
          stroke={'#22242D'}
          strokeWidth={'1.19639'}
        />
        <path
          d={
            'M14.2856 18.9822V23.7484C14.2856 23.7484 15.3953 25.4142 18.3705 25.4142C21.346 25.4142 22.6216 23.7484 22.6216 23.7484V18.7483'
          }
          stroke={'#22242D'}
          strokeLinecap={'round'}
          strokeWidth={'1.19639'}
        />
        <path
          d={
            'M17.7858 10.7486V10.0726L17.7858 6.94513C17.7858 6.28438 17.2501 5.74874 16.5894 5.74874H14.4858V7.2489H8.78577V5.74858L6.28575 5.74841C5.79627 5.74841 5.3999 6.14487 5.3999 6.63436L5.39993 21.3625C5.39993 21.852 5.7963 22.2484 6.28578 22.2484L9.28579 22.2487H11.7858'
          }
          stroke={'#22242D'}
          strokeWidth={'1.19639'}
        />
        <path
          d={
            'M8.78516 5.74878V5.23424L10.7591 5.23417C10.7591 4.68805 11.1984 4.24878 11.7445 4.24878C12.2906 4.24878 12.7299 4.68805 12.7299 5.23417H14.4852V5.74878'
          }
          stroke={'#22242D'}
          strokeMiterlimit={'10'}
          strokeWidth={'1.19639'}
        />
        <path d={'M24.7861 17.2489V21.2489'} stroke={'#22242D'} strokeWidth={'1.19639'} />
      </g>
      <defs>
        <clipPath id={'clip0_4357_1174'}>
          <rect
            fill={'white'}
            height={'24'}
            transform={'translate(2.28564 3.24841)'}
            width={'24'}
          />
        </clipPath>
      </defs>
    </svg>
  )
}
